import FaqsPageHeader from './FaqsPageHeader';

export default FaqsPageHeader;
